import { inject } from '@angular/core';
import { NgpDialogRef } from 'ng-primitives/dialog';

import { SuiDialogRef } from './sui-dialog-ref';
import { DialogCloseOptions } from './dialog-result';

/**
 * @template TData - the type of data passed TO the dialog (via config.data)
 * @template TResult - the type of data returned FROM the dialog (via close)
 */
export abstract class SuiDialogBase<TData = unknown, TResult = unknown> {
  /**
   * reference to the DIALOG
   * provides access to CLOSE Methods and closed Observable
   * this wraps the ng-primitives NgpDialogRef internally
   * to provide our DialogCloseEvent API
   */
  protected readonly dialogRef: SuiDialogRef<TData, TResult>;

  constructor() {
    const ngpRef = inject(NgpDialogRef<TData, any>);

    // Wrap it in our SuiDialogRef for API
    this.dialogRef = new SuiDialogRef<TData, TResult>(ngpRef);
  }

  protected get dialogData(): TData {
    return this.dialogRef.data as TData;
  }

  /**
   * @param options Dialog CLOSE OPTIONS - [reason, data?, focusOrigin?]
   *
   * @example - close with SAVE   -> this.close({ reason: DialogCloseReason.Save, data: formData });
   * @example - close with CANCEL -> this.close({ reason: DialogCloseReason.Cancel });
   */
  protected close(options: DialogCloseOptions<TResult>): void {
    this.dialogRef.close(options);
  }
}
